export default {
  "layoutWrapper": "L9cf6",
  "layout": "vE9Ul",
  "designOnLayout": "J9jpX",
  "designOnCell": "lYWhc",
  "cell": "NtaNa",
  "mobile": "_2E8N3"
};